import { useState } from "react";

interface HeroProps {
  onSearch: (keyword: string) => void;
}

export default function Hero({ onSearch }: HeroProps) {
  const [value, setValue] = useState("");

  const submit = () => {
    onSearch(value.trim());
  };

  return (
    <section
      id="home"
      className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20watermelon%20and%20playful%20gossip%20theme%20with%20sparkling%20stars%20and%20chat%20bubbles%2C%20warm%20coral%20red%20and%20melon%20green%20palette%2C%20vibrant%20modern%20flat%20art%2C%20energetic%20pop%20culture%20background&width=1600&height=900&seq=hero-gua-2026&orientation=landscape"
        alt="吃瓜视频在线娱乐资讯背景图"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl px-4 text-center md:px-6">
        <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 ring-1 ring-background-50/30">
          <i className="ri-fire-line text-accent-300"></i>
          热门视频每日实时更新
        </p>
        <h1 className="mt-5 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
          吃瓜视频在线，即点即看不等待
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-base text-background-100/90 md:text-lg">
          无需安装任何插件，网页直连即可秒开播放。高清流畅、极速缓冲，手机电脑都能看，热门吃瓜内容一站直达。
        </p>

        <div className="mx-auto mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row">
          <div className="flex flex-1 items-center gap-2 rounded-lg bg-background-50 px-4">
            <i className="ri-search-line text-lg text-foreground-400"></i>
            <input
              type="text"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && submit()}
              placeholder="搜索你想看的吃瓜视频..."
              className="h-12 w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="button"
            onClick={submit}
            className="inline-flex h-12 items-center justify-center gap-2 rounded-lg bg-primary-500 px-6 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-circle-line text-lg"></i>
            立即搜索
          </button>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-background-50">
          {[
            { num: "5000+", label: "精选视频" },
            { num: "30+", label: "内容栏目" },
            { num: "99%", label: "秒开播放" },
            { num: "24h", label: "实时更新" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-2xl text-accent-300 md:text-3xl">{s.num}</p>
              <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}